import { Building2, DoorOpen, Home, Landmark } from "lucide-react";
import PropertyTypeOptions from "./enums/PropertyTypeOptions";

export const PROPERTY_TYPE_ICONS = {
  [PropertyTypeOptions.HOUSE]: Home,
  [PropertyTypeOptions.CONDOMINIUM_HOUSE]: Landmark,
  [PropertyTypeOptions.APARTMENT]: Building2,
  [PropertyTypeOptions.FLAT]: DoorOpen,
} as const;
